export default __webpack_public_path__ + "static/logo-e08f87f42f9345461687ccc37cee4336.png";